import React, { useState } from 'react';
import styles from './styles.styl';
import cn from 'classnames/bind';
import { IAnalyticResultTableEntity } from 'src/redux/features/analytic/types';
import { Text } from '@consta/uikit/Text';
import { IconArrowDown } from '@consta/uikit/IconArrowDown';
import { formatDate } from 'src/utils';
import { SurveyTypeEnum } from 'src/utils/enum';
import { Badge } from '@consta/uikit/Badge';
import AnalyticsQuestionItem from '../AnalyticsQuestionItem/AnalyticsQuestionItem';

const cx = cn.bind(styles);

export interface IMySurveyItemProps {
  survey: IAnalyticResultTableEntity;
  name: string;
  type: SurveyTypeEnum;
}

const MySurveyItem: React.FC<IMySurveyItemProps> = ({ survey, name, type }) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  return (
    <div className={cx('MySurveyItem')}>
      <div>
        <div className={cx('MySurveyItem__container')}>
          <div className={cx('MySurveyItem__header')}>
            <div className={cx('MySurveyItem__label')}>
              <IconArrowDown
                onClick={() => setIsOpen(!isOpen)}
                view="secondary"
                className={cx('MySurveyItem__arrow', {
                  MySurveyItem__arrow_active: isOpen,
                })}
              />
              <div>
                <Text size="xl" weight="semibold">
                  {name}
                </Text>
                <Text view="ghost" size="xs">
                  Дата прохождения{' '}
                  {type === SurveyTypeEnum.TEST ? 'теста' : 'опроса'}{' '}
                  {formatDate(new Date(survey.date))}
                </Text>
              </div>
            </div>
            {type === SurveyTypeEnum.TEST && (
              <div className={cx('MySurveyItem__status')}>
                <Text>Баллов: {survey?.points}</Text>
                <Badge
                  label={`${
                    survey?.points >= survey?.passingScore ? '' : 'НЕ '
                  }ПРОЙДЕН`}
                  status={
                    survey?.points >= survey?.passingScore ? 'success' : 'error'
                  }
                />
              </div>
            )}
          </div>
          {isOpen && (
            <div className={cx('MySurveyItem__content')}>
              {survey.questions.map((item, index) => (
                <AnalyticsQuestionItem
                  number={index + 1}
                  key={index}
                  type={item.type}
                  question={item.title}
                  comment={item.comment}
                  userAnswers={item.answer}
                  answers={item.answers}
                  points={item?.points}
                  rating={item?.rating}
                  typeQuestion={type}
                />
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default MySurveyItem;
